import React from 'react';

import { Redirect } from "react-router-dom";
import CompClientesHoje from '../../components/DashBoard/compclienteshoje';


export default function ClientesHoje() {
        return (        
                    <div>
                      <CompClientesHoje />
                  </div>
                  );
 };

